export default {
  'Submit': 'Enviar',
  'Save': 'Guardar',
  'enterOTP': 'Confirma tu número de teléfono',
  'otpSent': 'Contraseña de un solo uso enviada',
  'login/signup': 'Registrarse /Iniciar sesión',
  'resendCode': 'Reenviar código',
  'edit': 'Editar',
  'otpMessage': 'Se ha enviado un código de 6 dígitos a su teléfono móvil',
  'oyo360WelcomeMessage': 'Bienvenido a OYO',
  'oyo360ResendCode': 'Reenviar codigo',
  'oyo360Edit': 'Editar',
  'oyo360otpMessage': 'Ingrese el código que hemos enviado a través de SMS a su número de teléfono móvil',
  'buttonActionContinue': 'Continuar',
  'chooseLanguage': 'Eligir idioma',
  'currentLanguage': 'IDIOMA ACTUAL',
  'otherLanguages': 'OTROS IDIOMAS',
  'google': 'Continuar con Google',
  'facebook': 'Continuar con Facebook',
  'or': 'o',
  'buttonActionSubmit': 'Enviar',
  'welcomeTitle': 'Bienvenido a OYO',
  'welcomeHeadingForMailLogin': 'Por favor, introducir la dirección de correo electrónico que registró con nosotros',
  'welcomeHeadingForPhoneLogin': 'Por favor, introducea el número de teléfono móvil que registraste con nosotros',
  'emailIdLabel': 'Dirección de correo electrónico',
  'welcomeHeadingForLogin': 'Ingrese el número de teléfono/ correo electrónico registrado con nosotros',
  'userNameLabel': 'Email ID/Número de Teléfono',
  'userNameErrorMessage':'Por favor ingrese el Correo Electronico/Número de Teléfono Correcto',
  'phoneNumberLabel': 'Número de teléfono',
  'passwordLabel': 'Contraseña',
  'newPasswordLabel': 'Nueva contraseña',
  'confirmNewPasswordLabel': 'Confirmar la nueva contraseña',
  'emailErrorMessage': 'Por favor, introducir la dirección de correo electrónico correcta',
  'phoneNumberErrorMessage': 'Por favor, introducir el número de teléfono correcto',
  'passwordErrorMessage': 'Por favor, introducir la contraseña correcta',
  'confirmPasswordErrorMessage': 'La contraseña no coincide.',
  'generateNewPassword': 'Crear una nueva contraseña',
  'loginButtonLabel': 'Iniciar sesión',
  'loginWithPhoneButtonLabel': 'Continuar con el teléfono',
  'loginWithOtp': 'Iniciar sesión con OTP',
  'loginWithEmailButtonLabel': 'Continuar con la dirección de correo electrónico',
  'back': 'Volver',
  'loginWithOtpTitle': 'Introducir el código de verificación',
  'loginWithOtpHeading': 'Se ha enviado un código de 6 dígitos a su teléfono',
  'listYourProperty': 'Publique su casa',
  'privacyPolicy': 'política de privacidad',
  'verifyEmail': 'Verificar la dirección de correo electrónico',
  'verifyMobile': 'Verificar el número de teléfono',
  'forgotPasswordPhoneSubHeading':
    'Le enviaremos un código de verificación de 6 dígitos para verificar su número de teléfono',
  'forgotPasswordMailSubHeading':
    'Le enviaremos un código de verificación de 6 dígitos para verificar su dirección de correo electrónico.',
  'newPasswordCondition1': 'Debe tener números y símbolos',
  'newPasswordCondition2': 'Debe tener al menos 8 caracteres',
  'newPasswordCondition3': 'Deben tener mayúsculas y minúsculas',
  'confirmLogin': 'Confirmar e iniciar sesión',
  'getOTP': 'Obtener OTP',
  'invalidInput': 'Entrada no válida',
  'passwordResetMessage': 'Contraseña creada con éxito',
  'otpErrorMessage': 'Por favor, introduzca la OTP correcta',
  'resendOtpSuccessMessage': 'La OTP fue reenviada con éxito a su número de teléfono',
  'InternalServerErrorMessage': 'Error interno del servidor',
  'resetPasswordHeading': 'Se ha enviado un código de 6 dígitos a su correo electrónico y número de teléfono',
  'signingIn': 'Iniciar sesión',
  'invalidMobileNumber': 'Número de teléfono no válido',
  'privacyFooterText': 'Al iniciar sesión en su cuenta, acepta nuestras {termsOfUse} y {privacyPolicy}',
  'and': 'y',
  'termsOfUse': 'condiciones de uso',
  'listProperty': 'Publique su casa',
  'whiteSpace': ' ',
  'errorNoAssociatedHotels': 'No tienes Hoteles asociados',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'mobileNumberPlaceholder': 'Introduzca un número de teléfono',
  'loginSubText': 'Introduzca su número de teléfono para convertirse en una casa de vacaciones de Belvilla en tan solo 30 minutos',
  'termsOfService': 'Términos de servicio',
  'termsOfServiceFooter': 'Al seleccionar Continuar a continuación, acepto los siguientes {termsOfService}',
  'secureInformation': 'No te preocupes, tu datos está segura con nosotros.',
  'mobileSearchPlaceholder': 'Búsqueda',
  'passwordChangeInformationText': 'Una vez cambiada su contraseña, se cerrará la sesión en todos los dispositivos'
};
